export const MODAL_INVEST_ID = 'invest-modal';
export const MODAL_CONNECTORS_ID = 'connectors-modal';

export const investStep = [
  'invest_initial',
  'select_asset',
  'redirect_broker',
  'send_order_advisor',
];
